import { makeAuthService } from './authService'
import { makeLookupsService } from './lookupsService'
import { makePermissionService } from './permissionService'
import { makeLivedataService } from './livedataService'
import { makeUserConfigService } from './userConfigService'
import { makeSecurityService } from './securityService'
import { makeSystemService } from './systemService'
import { makeGridsService } from './gridsService'
import { makeUtilityService } from './utilityService'
import { makeLogsService } from './logsService'
import { makeAMLService } from './amlService'
import { makeCRAService } from './craService'
import { makeCustomFieldsService } from './customFieldsService'
import { makeRatesService } from './ratesService'
import { makeLoanCalculatorService } from './loanCalculatorService'
import { makeLoanOfficerService } from './loanOfficerService'
import { makeProductService } from './productService'
import { makeTreasuryService } from './treasuryService'
import { makeClientService } from './clientService'
import { makeAccountService } from './accountService'
import { makeOpDayService } from './opdayService'
import { makeCollateralService } from './collateralService'
import { makeApplicationService } from './applicationService'
import { makePrintReportService } from './printReportService'
import { makeEventService } from './eventService'
import { makeLoanService } from './loanService'
import { makeReportingService } from './reportingService'
import { makeLinkedFilesService } from './linkedFilesService'
import { makeUCCService } from './uccService'
import { makeAccEntryService } from './accEntryService'

export const makeApi = (http, config) => ({
  auth: makeAuthService(http, config.backendUrl),
  lookups: makeLookupsService(http, config.backendUrl),
  permission: makePermissionService(http, config.backendUrl),
  livedata: makeLivedataService(http, config.backendUrl),
  userConfig: makeUserConfigService(http, config.backendUrl),
  security: makeSecurityService(http, config.backendUrl),
  system: makeSystemService(http, config.backendUrl),
  grids: makeGridsService(http, config.backendUrl),
  utility: makeUtilityService(http, config.backendUrl),
  logs: makeLogsService(http, config.backendUrl),
  aml: makeAMLService(http, config.backendUrl),
  cra: makeCRAService(http, config.backendUrl),
  customFields: makeCustomFieldsService(http, config.backendUrl),
  rates: makeRatesService(http, config.backendUrl),
  loanCalculator: makeLoanCalculatorService(http, config.backendUrl),
  loanOfficer: makeLoanOfficerService(http, config.backendUrl),
  product: makeProductService(http, config.backendUrl),
  treasury: makeTreasuryService(http, config.backendUrl), // obsolete
  client: makeClientService(http, config.backendUrl),
  account: makeAccountService(http, config.backendUrl),
  opday: makeOpDayService(http, config.backendUrl),
  collateral: makeCollateralService(http, config.backendUrl),
  application: makeApplicationService(http, config.backendUrl),
  printReport: makePrintReportService(http, config.backendUrl),
  event: makeEventService(http, config.backendUrl),
  loan: makeLoanService(http, config.backendUrl),
  reporting: makeReportingService(http, config.backendUrl),
  linkedFiles: makeLinkedFilesService(http, config.backendUrl),
  ucc: makeUCCService(http, config.backendUrl),
  accEntry: makeAccEntryService(http, config.backendUrl),
})

export type Api = ReturnType<typeof makeApi>

export { makeHttpService, applyRequestInterceptors, applyResponseInterceptors } from './httpService'
export { makeAppConfigService } from './appConfigService'
